// extracted by mini-css-extract-plugin
export default {"footerHeadContainer":"FooterHead_footerHeadContainer__zUTQZ","button3":"FooterHead_button3__5VU+O","affilatebutton":"FooterHead_affilatebutton__sf7im"};